/**
 * Checks if an object has a direct property (not inherited from prototype chain).
 * Provides a polyfill for Object.hasOwn for environments without ES2022 support.
 *
 * @param {Object} obj - The object to check
 * @param {string|symbol} key - The property key to check for
 * @returns {boolean} True if the object has the property as its own (not inherited)
 */
export const hasOwn = (obj, key) =>
	Object.hasOwn
		? Object.hasOwn(obj, key)
		: Object.prototype.hasOwnProperty.call(obj, key);
